// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingDialog.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import DashStyle from 'share/components/controls/Izenda.DashStyle';
import Thickness from 'share/components/controls/Izenda.Thinkness';
import localizer from 'share/localization/Izenda.Localizer';

@observer
export default class SettingDialog extends Component {
  static propsType = {
    title: PropTypes.string,
    showSetting: PropTypes.bool,
    value: PropTypes.object,
    onClosed: PropTypes.func
  };

  static defaultProps = {
    showSetting: false
  };

  constructor(props) {
    super(props);
    const value = props.value;
    this.state = {
      lineWidth: value.lineWidth,
      dashStyle: value.dashStyle
    };
  }

  componentWillReceiveProps(nextProps) {
    const value = nextProps.value || {};
    this.setState({
      lineWidth: value.lineWidth,
      dashStyle: value.dashStyle
    });
  }

  onClosed = type => {
    if (type === 'accept') {
      this.props.onClosed(this.state);
    }
    this.props.onClosed();
  };

  renderContainer() {
    const handleDashStyleChanged = dashStyle => {
      this.setState({
        dashStyle
      });
    };

    const handleThicknessChanged = thickness => {
      this.setState({
        lineWidth: thickness.value
      });
    };

    return (
      <div className="setting-dialog">
        <div className="row style">
          <span className="col-md-4">{localizer.getText('BORDER_SETTING_LABEL_DASH_STYLE')}</span>
          <div className="col-md-8">
            <DashStyle dashStyle={this.state.dashStyle} onChange={handleDashStyleChanged} />
          </div>
        </div>
        <div className="row thickness">
          <span className="col-md-4">{localizer.getText('BORDER_SETTING_LABEL_THICKNESS')}</span>
          <div className="col-md-8">
            <Thickness value={this.state.lineWidth} onChange={handleThicknessChanged} />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const props = this.props;
    return (
      <Popup visible={props.showSetting} onClosed={this.onClosed} type="none" sizeClass="modal-sm">
        <Popup.Header title={props.title} />
        <Popup.Body>{this.renderContainer()}</Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton key="accept" type="accept">
            {localizer.getText('COMMON_LABEL_OK')}
          </Popup.ConfirmationButton>
          <Popup.ConfirmationButton key="cancel" type="cancel">
            {localizer.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.SettingDialog.js